<template>
  <v-select
    :value="item.itemsPerPage"
    :label="$t('Lignes par page')"
    :items="rowsPerPage"
    item-text="label"
    item-value="value"
    outlined
    dense
    hide-details
    @input="item.itemsPerPage = parseInt($event, 10)"
  ></v-select>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { i18n } from '@/plugins/i18n'
import { useDatatablePagination } from '@/composables/useDatatablePagination'

export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { rowsPerPageItems } = useDatatablePagination()
    const rowsPerPage = rowsPerPageItems

    const item = computed({
      get: () => props.options,
      set: value => emit('update:object', value),
    })

    return {
      item,
      rowsPerPage,
    }
  },
}
</script>
